/**
 * Persistance du dernier email utilise pour signInWithOtp.
 *
 * Sert a deux scenarios :
 *   1. UX login : pre-remplir le champ email a la prochaine ouverture du
 *      LoginDialog (gain de temps a la connexion).
 *   2. Auto-recovery : sur SIGNED_OUT involontaire (storage purge par
 *      Safari ITP, token corrompu, etc.), relancer automatiquement un
 *      magic link sans demander a l'arbitre de retaper son adresse.
 *
 * Stocke via le hybridSupabaseStorage (localStorage + IndexedDB) pour
 * resister aux memes purges que les tokens. La cle est versionnee pour
 * permettre des migrations futures sans collision.
 */
import { hybridSupabaseStorage } from "./supabaseStorage";

const LAST_EMAIL_KEY = "gsf:last-signin-email:v1";

export async function getLastSigninEmail(): Promise<string | null> {
  try {
    return await hybridSupabaseStorage.getItem(LAST_EMAIL_KEY);
  } catch {
    return null;
  }
}

export async function setLastSigninEmail(email: string): Promise<void> {
  const trimmed = email.trim().toLowerCase();
  if (!trimmed) return;
  try {
    await hybridSupabaseStorage.setItem(LAST_EMAIL_KEY, trimmed);
  } catch {
    /* swallow — best-effort */
  }
}

export async function clearLastSigninEmail(): Promise<void> {
  try {
    await hybridSupabaseStorage.removeItem(LAST_EMAIL_KEY);
  } catch {
    /* swallow */
  }
}
